import { Hotjar, Userlane } from '@sennder/shell-utilities'

import {
  identifyUserInAnalytics,
  initAnalytics,
  resetAnalyticsSession,
  stopAnalytics,
} from './analytics'
import { HOTJAR_ID, USERLANE_ID, isProductionEnv } from '@/common/config'

import { logger } from '@/services/logger/loggers'
import { identifyUserInLogger, initLogger, stopLogger } from '@/services/logger'
import {
  identifyUserInMonitor,
  initMonitor,
  stopMonitor,
} from '@/services/monitor'
import { getStateData, getUserProfile } from '@/store'
import { executeSafelyWithLogging } from '@/services/errors-handler'

let state: 'stopped' | 'started' = 'stopped'

export function startTracking() {
  if (state === 'started') {
    return
  }

  initLogger()
  initMonitor()
  initAnalytics()

  if (isProductionEnv() && HOTJAR_ID) {
    const hotjar = new Hotjar(console, HOTJAR_ID)
    // This is an async func, but we don't want to wait for startTracking since it would block the entire page rendering
    hotjar.inject()
  }

  state = 'started'

  log('tracking has started')
}

export function identifyUserInTracking(onLogin = false) {
  if (state === 'stopped') {
    return
  }
  const profile = getUserProfile()

  identifyUserInAnalytics(onLogin)

  const { id, email } = profile

  identifyUserInLogger(id, email)
  identifyUserInMonitor(id, email)

  executeSafelyWithLogging(() => {
    if (USERLANE_ID) {
      const userlane = new Userlane(logger, USERLANE_ID)

      userlane.start(
        id,
        getStateData().roles.map((role) => role.name)
      )
    }
  }, 'userlane.start')

  log('user is identified')
}

export function anonymizeTracking() {
  if (state === 'stopped') {
    return
  }
  resetAnalyticsSession()

  log('user is anonymized')
}

export function stopTracking() {
  stopAnalytics()
  stopMonitor()
  stopLogger()
  state = 'stopped'

  log('tracking has stopped')
}

function log(message: string) {
  const prefix = '[tracking]'
  logger.info(`${prefix} ${message}`, {})
  console.log(`${prefix} ${message}`)
}
